export default __webpack_public_path__ + "static/media/capitol.6c08f8c9.svg";